<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-user-plus me-2"></i>
      Adicionar Contato
    </h5>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="cancelar()"></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="addContactForm" (ngSubmit)="onSubmit()">
      <!-- Campo Cliente -->
      <div class="mb-3">
        <label for="clienteId" class="form-label">
          Cliente <span class="text-danger">*</span>
        </label>
        
        <div class="position-relative">
          <div class="dropdown" [class.show]="dropdownClienteAberto">
            <input
              type="text"
              class="form-control form-control-sm dropdown-toggle"
              [class.is-invalid]="addContactForm.get('clienteId')?.invalid && addContactForm.get('clienteId')?.touched"
              placeholder="Selecione um cliente..."
              [(ngModel)]="buscaCliente"
              (input)="buscaClienteDebounce$.next(buscaCliente || '')"
              (focus)="abrirDropdownCliente()"
              (blur)="fecharDropdownCliente()"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            
            <div 
              class="dropdown-menu w-100" 
              [class.show]="dropdownClienteAberto" 
              style="max-height: 200px; overflow-y: auto;"
              (scroll)="onScrollClientes($event)"
            >
              <div *ngIf="clientesFiltrados.length === 0 && !clientePaginas.carregandoMais" class="dropdown-item-text text-muted">
                Nenhum cliente encontrado
              </div>
              <a 
                *ngFor="let cliente of clientesFiltrados" 
                class="dropdown-item" 
                href="#"
                (click)="$event.preventDefault()"
                (mousedown)="selecionarCliente(cliente)"
              >
                {{ cliente.nome }}
              </a>
              <div *ngIf="clientePaginas.carregandoMais" class="dropdown-item-text text-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
            </div>
          </div>
          
          <select
            id="clienteId"
            class="d-none"
            formControlName="clienteId"
          >
            <option value="">Selecione um cliente</option>
          </select>
        </div>
        
        <div class="invalid-feedback d-block" *ngIf="addContactForm.get('clienteId')?.invalid && addContactForm.get('clienteId')?.touched">
          Cliente é obrigatório.
        </div>
      </div>

      <!-- Campo Feira -->
      <div class="mb-3">
        <label for="feiraId" class="form-label">
          Feira <span class="text-danger">*</span>
        </label>
        
        <div class="position-relative">
          <div class="dropdown" [class.show]="dropdownFeiraAberto">
            <input
              type="text"
              class="form-control form-control-sm dropdown-toggle"
              [class.is-invalid]="addContactForm.get('feiraId')?.invalid && addContactForm.get('feiraId')?.touched"
              [disabled]="!addContactForm.get('clienteId')?.value"
              placeholder="Selecione uma feira..."
              [(ngModel)]="buscaFeira"
              (input)="buscaFeiraDebounce$.next(buscaFeira || '')"
              (focus)="abrirDropdownFeira()"
              (blur)="fecharDropdownFeira()"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            
            <div 
              class="dropdown-menu w-100" 
              [class.show]="dropdownFeiraAberto" 
              style="max-height: 200px; overflow-y: auto;"
            >
              <div *ngIf="feirasFiltradas.length === 0 && !isLoading" class="dropdown-item-text text-muted">
                Nenhuma feira encontrada
              </div>
              <a 
                *ngFor="let feira of feirasFiltradas" 
                class="dropdown-item" 
                href="#"
                (click)="$event.preventDefault()"
                (mousedown)="selecionarFeira(feira)"
              >
                {{ feira.nome }}
              </a>
              <div *ngIf="isLoading" class="dropdown-item-text text-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
              </div>
            </div>
          </div>
          
          <select
            id="feiraId"
            class="d-none"
            formControlName="feiraId"
          >
            <option value="">Selecione uma feira</option>
          </select>
        </div>
        
        <div class="invalid-feedback d-block" *ngIf="addContactForm.get('feiraId')?.invalid && addContactForm.get('feiraId')?.touched">
          Feira é obrigatória.
        </div>
        <small class="form-text text-muted" *ngIf="!addContactForm.get('clienteId')?.value">
          Selecione um cliente primeiro para carregar as feiras.
        </small>
      </div>

      <!-- Botões -->
      <div class="text-end">
        <button type="button" class="btn btn-outline-secondary btn-sm me-2" (click)="cancelar()">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="salvando">
          <span *ngIf="salvando" class="spinner-border spinner-border-sm me-2" role="status"></span>
          Adicionar Na lista
        </button>
      </div>
    </form>
  </div>
</div>

